module.exports = __webpack_public_path__ + "img/红井.423d22a0.png";